/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Projects_No_Projects_Get_StartedInputs */



/**
* | output |
* | --- |
* | "Create your first project to get started" |
*
* @param {Projects_No_Projects_Get_StartedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const projects_no_projects_get_started = /** @type {((inputs?: Projects_No_Projects_Get_StartedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Projects_No_Projects_Get_StartedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Erstelle dein erstes Projekt, um zu beginnen")
	return /** @type {LocalizedString} */ ("Create your first project to get started")
});